import { OrderPublicStatus } from '~/api/Order';
import { IconTypes } from '~/components/Icon/IconTypes';
import { MobileHeaderCardProps } from '~/components/MobileHeaderCard/interfaces';

export const getLabelDeclension = (
  length: number,
  label: [string, string] = ['item', 'items'],
): string => (length > 1 ? label[1] : label[0]);

export const getIconForStatus = (
  status?: OrderPublicStatus,
): IconTypes | undefined => {
  if (!status) {
    return;
  }

  const map: Partial<Record<OrderPublicStatus, IconTypes>> = {
    accepted: 'box-opened',
    picking: 'box-opened',
    ready_to_ship: 'box',
    ready_for_pickup: 'box',
    in_delivery: 'bike',
  };

  return map[status];
};

export const getBackgroundForStatus = (
  status?: OrderPublicStatus,
): MobileHeaderCardProps['backgroundVariant'] | undefined => {
  if (!status) {
    return;
  }

  const map: Partial<
    Record<OrderPublicStatus, MobileHeaderCardProps['backgroundVariant']>
  > = {
    accepted: 'picking',
    picking: 'picking',
    ready_to_ship: 'ready_to_ship',
    ready_for_pickup: 'ready_for_pickup',
    in_delivery: 'in_delivery',
  };

  return map[status];
};
